export default __webpack_public_path__ + "static/homepage_title_background_mobile-85f726ee1868623de0c8cacc4b8f9d40.png";